module.exports = __webpack_public_path__ + "static/media/GP.d6e7ec55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GP.svg
// module id = 2161
// module chunks = 7